// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--7ad44";